import { useState } from "react";

export const useDatosBancarios = () => {
  const errObj = {};
  const [datosBancariosErr, setErrors] = useState({});

  const validateBancarios = obj => {
    const { formaDePago, tipoCuenta, banco, numeroCuenta } = obj;
    if (!formaDePago) { errObj.formaDePago = "Requerido"; }
    if (formaDePago === "2" && !banco) { errObj.banco = "Requerido"; }
    if (formaDePago === "2" && !tipoCuenta) { errObj.tipoCuenta = "Requerido"; }
    if (formaDePago === "2" && !numeroCuenta) { errObj.numeroCuenta = "Requerido"; }

    setErrors(errObj);
  }

  return { datosBancariosErr, validateBancarios }
}